import React from 'react';
import EditCashBoxContext from 'contexts/EditCashBoxContext';
import 'styles/components/CashBoxAmounts.scss';
import { valueToCurrencyFormat } from 'utils/parseCurrency';
import { CashBoxCloseResponse } from 'types/models/CashBoxCloseResponse';
import { AttachMoney, MoneyOff, LocalAtm, CreditCard, ScannerSharp } from '@material-ui/icons';
import { t } from 'i18next';

export default ({ cashBoxCloseResponse }: { cashBoxCloseResponse: CashBoxCloseResponse | null }): JSX.Element => {
  const { selectedCashBox } = React.useContext(EditCashBoxContext);

  const movements = React.useMemo(() => {
    return [
      {
        name: 'Deposito',
        total: cashBoxCloseResponse?.transactions?.depositTotal ?? 0,
        icon: <AttachMoney />,
      },
      {
        name: 'Retiro',
        total: cashBoxCloseResponse?.transactions?.withdrawalTotal ?? 0,
        icon: <MoneyOff />,
      },
    ];
  }, [cashBoxCloseResponse]);

  const totalPerPaymentMethod = React.useMemo(() => {
    return [
      {
        name: 'Efectivo',
        total: cashBoxCloseResponse?.totalPerPaymentMethod?.cashBalance ?? 0,
        icon: <LocalAtm />,
      },
      {
        name: 'Qr',
        total: cashBoxCloseResponse?.totalPerPaymentMethod?.qrBalance ?? 0,
        icon: <ScannerSharp />,
      },
      {
        name: 'Tarjeta',
        total: cashBoxCloseResponse?.totalPerPaymentMethod?.cardBalance ?? 0,
        icon: <CreditCard />,
      },
    ];
  }, [cashBoxCloseResponse]);

  if (!selectedCashBox || !cashBoxCloseResponse) return <></>;

  return (
    <>
      <div className={'amount-main-container'}>
        <div className="amount-container">
          <h4>{t('cash-boxes-movements')}</h4>
          {movements.map((movement, index) => {
            return (
              <div className="row-container" key={index}>
                <div className="icon-container">
                  {movement.icon}
                  <p>{movement.name}</p>
                </div>
                <p>{valueToCurrencyFormat(movement.total)}</p>
              </div>
            );
          })}
        </div>

        <div className="amount-container">
          <h4>{t('cash-boxes-total-per-payment-method')}</h4>
          {totalPerPaymentMethod.map((total, index) => {
            return (
              <div className="row-container" key={index}>
                <div className="icon-container">
                  {total.icon}
                  <p>{total.name}</p>
                </div>
                <p>{valueToCurrencyFormat(total.total)}</p>
              </div>
            );
          })}
        </div>
      </div>

      <div className="products-container">
        <h4>{t('cash-boxes-products-sold')}</h4>
        {cashBoxCloseResponse.productsPerCategory.map((productCategory, index) => {
          return (
            <div className="products-row-container" key={index}>
              <h5>{productCategory.categoryName}</h5>
              <div className="products-quantity-container">
                {productCategory.products.map((product, index) => {
                  return (
                    <div className="row-container" key={index}>
                      {product.productName}
                      <p>x{product.quantity}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
